export default "__VITE_ASSET__Dg6R3nVz__"